import cn from "classnames";
import styles from "./SpeedDrops.module.scss";
import { ISpeedDropsProps } from "./SpeedDrops.props";
import { getDevivedHash } from "@utils/hash.utils";
import { memo, useEffect, useRef, useState } from "react";
import { Input } from "../Input/Input";

function SpeedDrops({
  name,
  up,
  className,
  defaultSpeed,
  defaultValue,
  reset,
  id,

  getValue,
  ...props
}: ISpeedDropsProps) {
  const firstRender = useRef<boolean>(true);
  const [lastValue] = useState(defaultSpeed);
  const [inputValue, setInputValue] = useState<string>("");
  const [value, setValue] = useState<string>("");
  const [percent_calc, setPercent_calc] = useState<number | undefined>();

  useEffect(() => {
    const f = (s: string) => {
      setInputValue(s);
      setValue(s);
    };
    f(defaultValue?.toString() || "");
  }, [defaultValue]);

  useEffect(() => {
    setValue(inputValue);
  }, [inputValue]);

  useEffect(() => {
    if (inputValue.length === 0) {
      setValue("");
      return;
    }
  }, [inputValue]);

  useEffect(() => {
    if (defaultSpeed === undefined || !!!inputValue) return;
    setPercent_calc((+inputValue * defaultSpeed) / 100);
  }, [inputValue]);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    if (defaultSpeed === undefined) return;
    if (defaultSpeed === lastValue) return;
    setPercent_calc((+inputValue * defaultSpeed) / 100);
  }, [defaultSpeed]);

  //for reset
  useEffect(() => {
    if (!reset) return;
    setInputValue("");
    setValue("");
  }, [reset]);

  useEffect(() => {
    if (!getValue) return;

    if (inputValue.length === 0) getValue("0");
    getValue(inputValue);
  }, [inputValue]);

  return (
    <div
      className={cn(styles.wrapper, className, {
        [styles.disabled]: !!props.disabled,
      })}
    >
      {up && <label>{name}</label>}
      {!!defaultSpeed && (
        <label className={styles.percent_calc}>
          {getDevivedHash(percent_calc)}
        </label>
      )}
      <Input
        type="number"
        value={inputValue?.toString()}
        onChange={(e) => {
          setInputValue(e.target.value);
        }}
        addonAfter="%"
        {...props}
      />
      {name && !up && <p>{name}</p>}
      {/* hidden value for form */}
      <input
        id={id}
        className={styles.hidden}
        tabIndex={-1}
        hidden
        defaultValue={value}
        type='text'
        data-calc={percent_calc && (percent_calc as number)}
        readOnly
      />
    </div>
  );
}
export default memo(SpeedDrops);
